import React from "react";
import { Box, Typography } from "@mui/material";
import TimePeriodSelection from "../../TimePeriodSelection";
import RollingAverageSection from "../../RollingAverageSection";
import type {
  TimePeriod,
  TimePeriodSelection as TimePeriodSelectionType,
} from "@store/slices/chart-config-slice";
import type { RollingAverageConfig } from "@/utils/rolling-average-utils";

interface TimePeriodSectionProps {
  timePeriodSelection: TimePeriodSelectionType;
  rollingAverage: RollingAverageConfig;
  statisticalTestingEnabled: boolean;
  responsesMinDate?: string;
  responsesMaxDate?: string;
  isDisabled: boolean;
  totalAvailablePeriods?: number;
  onTimePeriodChange: (timePeriod: TimePeriod) => void;
  onTimePeriodDatesChange: (dates: {
    startDate: string | null;
    endDate: string | null;
  }) => void;
  onRollingAverageEnabledChange: (enabled: boolean) => void;
  onRollingAverageWindowSizeChange: (size: number) => void;
  guardrailAllowedWindowSizes?: number[];
  guardrailNoRollingDisabled?: boolean;
  guardrailRollingDisabled?: boolean;
  guardrailConflictWarning?: string;
}

const TimePeriodSection: React.FC<TimePeriodSectionProps> = ({
  timePeriodSelection,
  rollingAverage,
  statisticalTestingEnabled,
  responsesMinDate,
  responsesMaxDate,
  isDisabled,
  totalAvailablePeriods,
  onTimePeriodChange,
  onTimePeriodDatesChange,
  onRollingAverageEnabledChange,
  onRollingAverageWindowSizeChange,
  guardrailAllowedWindowSizes,
  guardrailNoRollingDisabled,
  guardrailRollingDisabled,
  guardrailConflictWarning,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Time Period
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 2,
        }}
      >
        <TimePeriodSelection
          timePeriodSelection={timePeriodSelection}
          onTimePeriodChange={onTimePeriodChange}
          onTimePeriodDatesChange={onTimePeriodDatesChange}
          statisticalTestingEnabled={statisticalTestingEnabled}
          responsesMinDate={responsesMinDate}
          responsesMaxDate={responsesMaxDate}
          disabled={isDisabled}
        />

        <RollingAverageSection
          enabled={rollingAverage?.enabled || false}
          windowSize={rollingAverage?.windowSize || 2}
          timePeriod={timePeriodSelection?.timePeriod || "all_time"}
          totalAvailablePeriods={totalAvailablePeriods}
          onEnabledChange={onRollingAverageEnabledChange}
          onWindowSizeChange={onRollingAverageWindowSizeChange}
          disabled={isDisabled}
          guardrailAllowedWindowSizes={guardrailAllowedWindowSizes}
          guardrailNoRollingDisabled={guardrailNoRollingDisabled}
          guardrailRollingDisabled={guardrailRollingDisabled}
          guardrailConflictWarning={guardrailConflictWarning}
        />
      </Box>
    </Box>
  );
};

export default TimePeriodSection;
